import { z } from 'zod';
import { JUDGEMENT_FILTER_VALUES } from '@/features/ai-matching-results/lib/judgementFilter';
import { getCurrentFiscalYear } from '@/shared/lib/fiscal-year';

/**
 * 財源マッチング一覧の絞り込み用 URL 検索パラメータ。
 *
 * - year: 事業年度（必須）。未指定時は現在年度をデフォルトにする
 * - judgements: 判定での絞り込み（複数選択）。API 語彙に合わせる（未指定＝全件）
 *
 * 旧 URL / 不正値でルートロードが失敗しないよう、各フィールドは `.catch()` で寛容にする
 * （`/fe-router-pitfalls` 準拠）。
 *
 * year はあえて `.default()` を付けず `.optional()` のままにする。URL 未指定時を `undefined` として
 * 検出できるようにし（localStorage からの復元判定に使う）、現在年度のフォールバックはページ側で行う。
 */
export const fundingListSearchSchema = z.object({
  year: z.number().int().min(1900).max(2100).catch(getCurrentFiscalYear()).optional(),
  judgements: z.array(z.enum(JUDGEMENT_FILTER_VALUES)).catch([]).optional(),
});
